// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__kif6G","select":"Header_select__3B9p3","clinic":"Header_clinic__1-KV7"};